module.exports = __webpack_public_path__ + "static/media/redOnion.1084cfb6.png";